import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    { id: true, Nombre: i18n.t('app.archived') },
    { id: false, Nombre: i18n.t('app.not_archived') }
  ]
}

export function OPCIONES_ARCHIVADO (state) {
  return configHelper.getConfig(state, 'OPCIONES_ARCHIVADO', GenerateConfig)
}
